import { RouteObject } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import RouteProtector from "./RouteProtector";

const CreditCardSuccess = lazyWithReload(
  () => import("src/creditCard/features/paymentForm/CreditCardSuccess"),
);

export const creditCard: RouteObject = {
  path: "/cardPayment",
  children: [
    {
      path: "successPayment",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <CreditCardSuccess />
        </RouteProtector>
      ),
    },
  ],
};